<template>
    <div>
        <h1>Revenue Calculator</h1>
        <div>
            <p>From: <input id="start" type="date" /> To (days end of): <input id="end" type="date" /> <button
                    @click="getData">Fetch</button></p>
            <p v-show="thinking">Loading...</p>
        </div>

        <!-- Checkbox to hide zero values -->
        <div>
            <label>
                <input type="checkbox" v-model="hideZeroValues" /> Hide Zero Values
            </label>
        </div>

        <table>
            <tr>
                <th>Building Name</th>
                <th>Address</th>
                <th>Revenue ($)</th>
                <th>Overdues ($)</th>
                <th>Total ($)</th>
                <th>Stripe Total ($)</th>
                <th>Transactions</th>
            </tr>
            <!-- Use filteredFees instead of fees -->
            <tr v-for="f in filteredFees" :key="f.BuildingId">
                <td>{{ f.BuildingName }}</td>
                <td>{{ f.Address }}</td>
                <td>${{ f.Revenue.toFixed(2).padStart(8, ' ') }}</td>
                <td>${{ f.Overdues.toFixed(2).padStart(8, ' ') }}</td>
                <td>${{ (f.Revenue + f.Overdues).toFixed(2).padStart(8, ' ') }}</td>
                <td>${{ f.StripeTotal.toFixed(2).padStart(8, ' ') }}</td>
                <td>
                    <button @click="showTransactions(f.StripeTransactions)">
                        {{ f.StripeTransactions.length }} items
                    </button>
                </td>
            </tr>
            <!-- Totals row -->
            <tr>
                <td colspan="2">Totals</td>
                <td></td>
                <td></td>
                <td>${{ totals.total }}</td>
                <td>${{ totals.stripeTotal }}</td>
                <td></td>
            </tr>
        </table>

        <!-- Modal for transactions (unchanged) -->
        <div v-if="showModal" class="modal">
            <div class="modal-content">
                <span class="close" @click="closeModal">×</span>
                <h2>Stripe Transactions</h2>
                <table>
                    <tr>
                        <th>Transaction ID</th>
                        <th>Amount ($)</th>
                        <th>Stripe ID</th>
                        <th>Created At</th>
                    </tr>
                    <tr v-for="tx in currentTransactions" :key="tx.TransactionId">
                        <td>{{ tx.TransactionId }}</td>
                        <td>${{ (tx.Amount / 100).toFixed(2) }}</td>
                        <td>{{ tx.StripeId }}</td>
                        <td>{{ new Date(tx.createdAt).toLocaleString() }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { CallApi } from '../Utilities.js';

export default {
    data: function () {
        return {
            fees: [],
            thinking: false,
            showModal: false,
            currentTransactions: [],
            hideZeroValues: false
        };
    },
    computed: {
        filteredFees: function () {
            if (!this.hideZeroValues) {
                return this.fees;
            }
            return this.fees.filter(f => {
                const total = f.Revenue + f.Overdues;
                return f.Revenue !== 0 || f.Overdues !== 0 || total !== 0 || f.StripeTotal !== 0;
            });
        },
        totals: function () {
            let total = 0;
            let stripeTotal = 0;
            this.filteredFees.forEach(f => {
                total += f.Revenue + f.Overdues; // Sum of Total ($)
                stripeTotal += f.StripeTotal;     // Sum of Stripe Total ($)
            });
            return {
                total: total.toFixed(2),
                stripeTotal: stripeTotal.toFixed(2)
            };
        }
    },
    methods: {
        getData: async function () {
            let AuthCredentials = { Email: "hayden@myparcellocker.com", Password: "123123" };
            let startDate = document.getElementById('start').value + "T00:00:00.000Z";
            let endDate = document.getElementById('end').value + "T23:59:59.999Z";
            let JWTToken = null;
            let AllLockerIDs = [];
            this.fees = [];
            this.thinking = true;

            try {
                const rawLogin = await fetch('https://api.mplocker.com/auth/dashboard/login', {
                    method: 'POST',
                    body: JSON.stringify(AuthCredentials),
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                });
                const loginData = await rawLogin.json();
                if (loginData.success) {
                    JWTToken = loginData.accessToken;
                } else {
                    return;
                }

                const rawGetLockerIDs = await fetch('https://api.mplocker.com/api/Admin/BuildingIdList', {
                    method: 'GET',
                    headers: { 'Accept': 'application/json', 'Authorization': 'Bearer ' + JWTToken },
                });
                const BuildingIdList = await rawGetLockerIDs.json();
                BuildingIdList.forEach(row => AllLockerIDs.push(row.BuildingId));

                const payload = { Start: startDate, Finish: endDate, BuildingIds: AllLockerIDs };
                const rawStats = await fetch('https://api.mplocker.com/api/Admin/BuildingStats', {
                    method: 'POST',
                    body: JSON.stringify(payload),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JWTToken,
                    },
                });
                const stats = await rawStats.json();

                const rawStripeRevenue = await fetch('https://api.mplocker.com/api/Admin/StripeRevenue', {
                    method: 'POST',
                    body: JSON.stringify(payload),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JWTToken,
                    },
                });
                const stripeRevenue = await rawStripeRevenue.json();

                const stripeMap = {};
                stripeRevenue.forEach(stripe => {
                    stripeMap[stripe.BuildingId] = {
                        StripeTotal: stripe.TotalStripeAmount / 100,
                        StripeTransactions: stripe.StripeTransactions,
                    };
                });

                this.fees = [];
                Object.keys(stats).forEach(buildingId => {
                    const building = stats[buildingId];
                    const stripeInfo = stripeMap[buildingId] || { StripeTotal: 0, StripeTransactions: [] };
                    let overdueFees = 0;
                    Object.keys(building.Months).forEach(month => {
                        overdueFees += building.Months[month].OverdueRevenue;
                    });

                    this.fees.push({
                        BuildingId: buildingId,
                        BuildingName: building.BuildingName,
                        Address: building.Address,
                        Revenue: building.Total.Revenue / 100,
                        Overdues: overdueFees / 100,
                        StripeTotal: stripeInfo.StripeTotal,
                        StripeTransactions: stripeInfo.StripeTransactions,
                    });
                });
                let totalOld = 0;
                let totalStripe = 0;
                this.fees.forEach(f => {
                    totalOld += f.Revenue + f.Overdues;
                    totalStripe += f.StripeTotal;
                });
                const difference = totalStripe - totalOld;

                console.log(`Total of all Total ($): $${totalOld.toFixed(2)}`);
                console.log(`Total of all Stripe Total ($): $${totalStripe.toFixed(2)}`);
                console.log(`Total difference between Stripe Total and Old Total: $${difference.toFixed(2)}`);
            } catch (e) {
                console.log(e);
                alert("Error Encountered - Contact Hayden");
                return;
            }
            this.thinking = false;
        },
        showTransactions: function (transactions) {
            this.currentTransactions = transactions;
            this.showModal = true;
        },
        closeModal: function () {
            this.showModal = false;
            this.currentTransactions = [];
        },
    },
};
</script>

<style>
.modal {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>